import React from 'react';
import { useTranslation } from 'react-i18next';
import DarkCityPanoramaImage from '../../assets/images/dark_city_panorama.webp';
import { MdOutlineWarning } from 'react-icons/md';

export default function LandingPage(props: { scrollToReport: () => void }) {
    const { t } = useTranslation();
    return (
        <div>
            <div
                className={'h-screen bg-cover bg-center bg-no-repeat py-[15vh] text-white'}
                style={{
                    backgroundImage: `linear-gradient(0deg,rgba(16,16,43,.3),rgba(16,16,43,.3)),url(${DarkCityPanoramaImage})`,
                }}>
                <div
                    className={
                        'flex h-full w-full flex-col items-center justify-center bg-slate-900/50 px-3 sm:px-0'
                    }>
                    <h1
                        className={
                            'flex flex-col items-center text-center font-montserrat text-3xl font-medium uppercase sm:text-5xl'
                        }>
                        {t('SM')}
                        <div className={'mt-1 h-1 w-1/2 rounded bg-SM-yellow'} />
                    </h1>

                    <p className={'mt-4 max-w-2xl text-center'}>
                        {t('MAIN_PAGE.LANDING_PAGE.QUICK_INFO_ABOUT')}
                    </p>

                    <div className={'mt-4 flex flex-wrap justify-center gap-x-10 gap-y-5'}>
                        <button
                            className={
                                'btn-filled bg-SM-yellow text-sm text-white ring-SM-yellow/50 sm:text-lg '
                            }
                            onClick={props.scrollToReport}>
                            <MdOutlineWarning className={'text-2xl'} />
                            {t('MAIN_PAGE.LANDING_PAGE.REPORT')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
